import { Segment } from '@/redux/slices/packagingSlice.types';
import { type RootState } from '@/redux/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectPackagingSlice = (state: RootState) => state?.packaging;
export const selectPackagingActiveTemplate = createSelector(selectPackagingSlice, (packaging) => packaging.activeTemplate);
export const selectPackagingActiveCutType = createSelector(selectPackagingSlice, (packaging) => packaging.activeCutType);
export const selectPackagingActiveHover = createSelector(selectPackagingSlice, (packaging) => packaging.activeHover);
export const selectIsPackagingDraft = createSelector(
  selectPackagingSlice,
  (slice): boolean => slice?.contentAssembly?.assembly_template_inputs?.status === 'DRAFT' || true
);
export const selectIsReadOnlyPackaging = createSelector(selectPackagingSlice, (packaging) => {
  return packaging.contentAssembly?.status === 'complete';
});

export const selectPackagingLoadingStatus = createSelector(selectPackagingSlice, (packaging) => packaging.loadingStatus);
export const selectPackagingIsEditingTimeline = createSelector(selectPackagingSlice, (packaging) => packaging.isEditingTimeline);
export const selectPackagingOptions = createSelector(selectPackagingSlice, (packaging) => packaging.toolboxOptions);
export const selectPackagingContentAssembly = createSelector(selectPackagingSlice, (packaging) => packaging.contentAssembly);

export const selectPackagingTimelineScale = createSelector(selectPackagingSlice, (packaging) => packaging.timelineScale);
export const selectPackagingTimelineFrameRate = createSelector(selectPackagingSlice, (packaging) => packaging.timelineFrameRate);

/**
 * @return frameDuration - the duration of single frame for a given frame rate. For example if frame rate is 25 fps
 * frameDuration is 1000 ms / 25 fps = 40 ms.
 */
export const selectPackagingTimelineFrameDuration = createSelector(
  selectPackagingTimelineFrameRate,
  (frameRate) => 1000 / (frameRate[0] / frameRate[1])
);

export const selectMovingOverlayData = createSelector(selectPackagingSlice, (packaging) => packaging.movingOverlayData);
export const selectMovingOverlayNewPosition = createSelector(selectMovingOverlayData, (movingOverlayData): Segment | null => {
  if (movingOverlayData && movingOverlayData.newStart !== null && movingOverlayData.newEnd !== null) {
    return { start: movingOverlayData.newStart, end: movingOverlayData.newEnd };
  }

  return null;
});

export const selectPlayerCurrentFrame = createSelector(selectPackagingSlice, (packaging) => packaging.playerCurrentFrame);
export const selectIsPlayerOpened = createSelector(selectPackagingSlice, (packaging) => packaging.isPlayerOpened);
export const selectIsPlaying = createSelector(selectPackagingSlice, (packaging) => packaging.isPlaying);
export const selectIsToolboxDrawerOpen = createSelector(selectPackagingSlice, (packaging) => packaging.isToolboxDrawerOpen);

export const selectInventoryModalSelectedFile = createSelector(selectPackagingSlice, (packaging) => packaging.inventoryAssignmentModal.selectedFile);
export const selectInventoryModalPreviewedFile = createSelector(
  selectPackagingSlice,
  (packaging) => packaging.inventoryAssignmentModal.previewedFile
);
